export function prepareModalList(initalMessage, items) {
  let result = ''
  items.forEach((el) => (result += `<li class="my-2">- ${el}</li>`))
  result = `<ul class="modal-list-unstyled">${result}</ul>`

  return initalMessage + result
}
